import { Action } from '@ngrx/store';
//beacon
import { createMetaReducer } from 'redux-beacon';
import {
  GoogleAnalytics,
  PageView,
  Event,
  Exception
} from 'redux-beacon/targets/google-analytics';

// import { logger } from 'redux-beacon/extensions/logger'; // if need to log to console

// Define an event
const pageView = (action: Action): PageView => ({
  hitType: 'pageview',
  page: action.payload.path,
});

// Map the event to an ngrx/store action
const eventsMap = {
  '[Router] Update Location': pageView,
};

// Create the meta Reducer
export const analyticsRouterMetaReducer = createMetaReducer(eventsMap, GoogleAnalytics);



// WEBPACK FOOTER //
// ./src/app/stateManagement/reducers/metaReducer/router.metaReducer.ts